import React from 'react';
import styles from './PDColumnCard.module.scss';
import { ReactComponent as ProductDistribution } from 'assets/icons/distribution.svg';
import clsx from 'clsx';
import { Tooltip, Typography } from 'antd';
import EmissionCalculationError from '../EmissionCalculationError';
import formatNumberWithCommas from 'shared/utils/formatNumberWithComma';

interface componentPropsInterface {
  style?: React.CSSProperties;
}

export interface PDColumnCardProps {
  id?: string;
  name?: string;
  weight?: string;
  carbon?: string;
  legType?: string;
  emission: number;
  isDownloadPage?: boolean;
}

const PDColumnCard = ({
  name,
  weight,
  carbon,
  id,
  emission,
  legType,
  isDownloadPage,
  ...componentProps
}: PDColumnCardProps & componentPropsInterface) => {
  const handleColorByEmission = (value: number) => {
    let category = '';
    if (value >= 0 && value <= 20) {
      category = 'blue';
    } else if (value > 20 && value <= 40) {
      category = 'green';
    } else if (value > 40 && value <= 60) {
      category = 'yellow';
    } else if (value > 60 && value <= 80) {
      category = 'orange';
    } else if (value > 80 && value <= 100) {
      category = 'red';
    }

    return category;
  };
  const { style } = componentProps;
  const isError = legType === '' || legType === undefined ? true : false;
  const carbonEmissionValue = parseFloat(carbon ?? '').toFixed(4);

  return (
    <div id={id} style={style} className="canvas-card">
      <EmissionCalculationError showError={isError}>
        <div
          className={clsx({
            [styles.cardContainer]: true,
            [styles.hasTooltip]: !isDownloadPage,
            [styles.green]: handleColorByEmission(emission) === 'green',
            [styles.blue]: handleColorByEmission(emission) === 'blue',
            [styles.yellow]: handleColorByEmission(emission) === 'yellow',
            [styles.orange]: handleColorByEmission(emission) === 'orange',
            [styles.red]: handleColorByEmission(emission) === 'red',
            [styles.error]: isError,
          })}>
          <div className={styles.contentContainer}>
            <div className={styles.iconContainer}>
              <ProductDistribution />
            </div>
            <div className={styles.dataContainer}>
              <div className={styles.label}>
                <Tooltip title={name}>
                  <Typography.Paragraph
                    className={styles.pdname}
                    ellipsis={!isDownloadPage && { rows: 2 }}>
                    <p>{name}</p>
                  </Typography.Paragraph>
                </Tooltip>
              </div>
              <div className={styles.data}>
                <p>
                  {formatNumberWithCommas(carbonEmissionValue)} kgCO<sub>2</sub>
                  e
                </p>
              </div>
            </div>
          </div>
          <div
            className={clsx({
              [styles.extendedLine]: true,
              [styles.greenLine]: handleColorByEmission(emission) === 'green',
              [styles.blueLine]: handleColorByEmission(emission) === 'blue',
              [styles.yellowLine]: handleColorByEmission(emission) === 'yellow',
              [styles.orangeLine]: handleColorByEmission(emission) === 'orange',
              [styles.redLine]: handleColorByEmission(emission) === 'red',
            })}></div>
        </div>
      </EmissionCalculationError>
    </div>
  );
};
export default PDColumnCard;
